import { render } from "./AdminHome.vue?vue&type=template&id=1faae450"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__